const GEO_ISP = 'GEO_ISP';
const GEO_ASN = 'GEO_ASN';

export default (dimensionList, dimensionName, name, value) => {
  let dimensionField: string | null = null;
  // let dimensionKey = null;
  // dimensionField might be changed when ASN is used to resolve ISP
  // track the originalField for creating filters
  // filters using the same originalField should be OR together
  let originalField: string | null = null;
  const dimension = dimensionList.find(
    (originDimension) => originDimension.dimension_name === dimensionName,
  );

  if (dimension) {
    dimensionField = dimension.dimension_name;
    originalField = dimensionField;
    // if (dimensionField === DIMENSION_TAG) {
    //   dimensionKey = dimension.group_by;
    // }
    if (dimensionField === GEO_ISP && !value.startsWith('isp:')) {
      dimensionField = GEO_ASN;
    }
  }
  return {
    field: dimensionField,
    key: dimensionField,
    op: 'eq',
    value: value || '',
    display: value || '',
    originalField,
  };
};
